<template>
    <div class="feedback_main" v-click-outside="isNoShowForm">
        <div class="main_edit" @click.stop="isShowForm" @mouseover="isTextShow = true" @mouseout="isTextShow = false">
            <div class="main_edit_img"></div>
            <transition name="fade">
                <div class="main_edit_text" v-show="isTextShow">提交<br>反馈</div>
            </transition>
        </div>
        <div class="main_form" v-show="isFormShow">
            <span class="form_close" @click="isFormShow = false"></span>
            <div v-show="!isSendSpit">
                <div class="form_head">
                    <p>你想吐槽的原因是：</p>
                    <ul>
                        <li v-for="(item, index) in spitBadList" :key="index" @click="addContent(item)">{{item}}</li>
                    </ul>
                </div>
                <div class="form_content">
                    <p>再说点什么</p>
                    <textarea placeholder="使用中有哪些不爽啊，各种错误啊，马上反馈给我吧~" v-model="formContent" ref="form_content" maxlength="150" @keyup="formCheck" @blur="formCheck"></textarea>
                    <p class="form_notice" v-show="isContentNotice">请尽量详细描述您的意见</p>
                    <span>{{formContent.length | limitlength}}/150</span>
                </div>
                <div class="form_submit">
                    <label>
                        联系方式：<input type="text" placeholder="留下您的联系方式，我们会及时答复您" v-model="formTel">
                    </label>
                    <span @click="submitSpit">提交</span>
                </div>
            </div>
            <div class="form_send" v-show="isSendSpit"></div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    export default {
        name: 'feedback',
        data () {
            return {
                isTextShow: false,
                isFormShow: false,
                formContent: '',
                formTel: '',
                isContentNotice: false,
                contentLength: '',
                isSendSpit: false,
                spitBadList: ['内容不详细', '数据有问题', '规则不合理', '功能不好用', '界面不好看']
            }
        },
        created () {
        },
        filters: {
            limitlength: function (num) {
                if (Number(num) <= 150) {
                    return Number(num)
                } else {
                    return 150
                }
            }
        },
        methods: {
            isShowForm: function () {
                this.isFormShow = !this.isFormShow
                this.formContent = ''
                this.formTel = ''
                this.isSendSpit = false
            },
            isNoShowForm: function () {
                this.isFormShow = false
            },
            addContent: function (val) {
                var reg = new RegExp(val)
                if (!reg.test(this.formContent)) {
                    this.formContent += val + ','
                }
                if (this.formContent.length > 150) {
                    this.formContent = this.formContent.substr(0, 150)
                }
                this.$refs.form_content.focus()
            },
            formCheck: function () {
                if (this.formContent.length > 0) {
                    this.isContentNotice = false
                }
            },
            submitSpit: function () {
                var self = this
                if (this.formContent.length === 0) {
                    this.isContentNotice = true
                } else {
                    axios.post('/feedback', {
                        message: this.formContent,
                        contact: this.formTel
                    }).then((res) => {
                        if (!res.data.errorcode) {
                            this.isSendSpit = true
                        }
                    }).catch(function (error) {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                }
            }
        },
        mounted () {
        }
    }
</script>
<style lang="scss" scoped>
@import '../../scss/common/feedback.scss';
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/lib/feedback.vue